<div class="account-notes-container">
  <h3>Account Notes</h3>
  <div *ngIf="accounts.length > 0">
    <p><strong>Investor Name:</strong> {{ accounts[0].investorName }}</p>
    <!--<p><strong>Account Name:</strong> {{ accounts[0]?.accountName }}</p>-->
  </div>
  <button class="btn btn-primary" (click)="openPopup()">Add Note</button>
  <dx-data-grid [dataSource]="notes"
                [columns]="noteColumns"
                [showBorders]="true"
                [columnAutoWidth]="true"
                [allowColumnResizing]="true"
                [rowAlternationEnabled]="true"
                [allowColumnReordering]="true">
    <div *dxTemplate="let data of 'deleteButtonTemplate'">
<!--      <div *dxTemplate="let data of 'deleteButtonTemplate'; let index = index; trackBy: trackByNoteId">-->
        <!-- Show Delete button if isDeleted is false -->
        <button *ngIf="!data.data.isDeleted"
                class="btn btn-danger"
                [disabled]="!canDelete(data.data)"
                (click)="deleteNote(data.data)">
          Delete
        </button>
        <!-- Show Undelete button if isDeleted is true -->
        <button *ngIf="data.data.isDeleted"
                class="btn btn-success"
                [disabled]="!canDelete(data.data)"
                (click)="deleteNote(data.data)">
          Undelete
        </button>
      </div>
</dx-data-grid>
  <dx-popup [(visible)]="popupVisible"
            [width]="600"
            [height]="400"
            [showTitle]="true"
            title="Add Note"
            [dragEnabled]="true"
            [hideOnOutsideClick]="true">
    <app-add-note [accounts]="accounts" (noteAdded)="onNoteAdded($event)"></app-add-note>
  </dx-popup>
</div>
